import { Component } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center min-h-[400px] p-8">
          <div className="text-center max-w-md">
            <AlertTriangle className="w-12 h-12 text-amber-500 mx-auto mb-4" />
            <h2 className="text-xl font-bold text-foreground mb-2">Er is iets misgegaan</h2>
            <p className="text-sm text-muted-foreground mb-6">Deze pagina heeft een fout ondervonden. Probeer de pagina te herladen.</p>
            <Button onClick={() => { this.setState({ hasError: false }); window.location.reload(); }} className="bg-[#2CA8AC] hover:bg-[#248F92]">
              Pagina Herladen
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
